import React from 'react'
import Layout from '../components/layouts/Layout'

const Pagenotfound = () => {
  return (
    <Layout>
             <h1>opps... Page not found!!!</h1>
    </Layout>
  )
}

export default Pagenotfound